var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 76,
    viewBox: "0 0 72 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_12_13921)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81042 27.1351C7.79291 26.961 7.86295 26.7957 7.98552 26.6782L35.4372 38.08C35.5861 38.1322 35.7349 38.1627 35.8881 38.1757L35.8794 65.3399C35.6299 65.3138 35.3891 65.2485 35.1571 65.1484L8.44955 53.4768C8.08183 53.3245 7.83669 52.9763 7.80167 52.5847V27.1395L7.81042 27.1351Z",
    fill: "url(#paint0_linear_12_13921)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M7.81042 27.1351C7.79291 26.961 7.86295 26.7957 7.98552 26.6782L35.4372 38.08C35.5861 38.1322 35.7349 38.1627 35.8881 38.1757L35.8794 65.3399C35.6299 65.3138 35.3891 65.2485 35.1571 65.1484L8.44955 53.4768C8.08183 53.3245 7.83669 52.9763 7.80167 52.5847V27.1395L7.81042 27.1351Z",
    fill: "url(#paint1_linear_12_13921)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M7.98084 26.6776C7.85826 26.7951 7.78822 26.9605 7.80573 27.1346V41.8003H35.8878V38.1708C35.7346 38.1578 35.5858 38.1273 35.4369 38.0751L7.98521 26.6733L7.98084 26.6776Z",
    fill: "url(#paint2_linear_12_13921)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9699 27.1347C63.9874 26.9607 63.9173 26.7953 63.7948 26.6778L36.343 38.0796C36.1942 38.1318 36.0454 38.1623 35.8922 38.1754L35.9009 65.3396C36.1504 65.3134 36.3912 65.2482 36.6232 65.1481L63.3307 53.4764C63.6984 53.3241 63.9436 52.976 63.9786 52.5843V27.1391L63.9699 27.1347Z",
    fill: "url(#paint3_linear_12_13921)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M63.9699 27.1347C63.9874 26.9607 63.9173 26.7953 63.7948 26.6778L36.343 38.0796C36.1942 38.1318 36.0454 38.1623 35.8922 38.1754L35.9009 65.3396C36.1504 65.3134 36.3912 65.2482 36.6232 65.1481L63.3307 53.4764C63.6984 53.3241 63.9436 52.976 63.9786 52.5843V27.1391L63.9699 27.1347Z",
    fill: "url(#paint4_linear_12_13921)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M35.958 38.1667C35.9362 38.1667 35.9099 38.1754 35.888 38.1754L35.8968 65.3396C35.9186 65.3396 35.9449 65.3309 35.9668 65.3265L35.958 38.1667Z",
    fill: "url(#paint5_linear_12_13921)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M36.3433 38.1273C36.1945 38.1796 36.0457 38.21 35.8881 38.2231C35.7349 38.21 35.5816 38.1796 35.4328 38.1273L8.23062 26.83L7.86728 26.9823L35.4328 38.4276C35.5816 38.4798 35.7305 38.5103 35.8881 38.5234C36.0413 38.5103 36.1945 38.4798 36.3433 38.4276L63.9089 26.9823C63.9089 26.9823 63.5543 26.8343 63.5455 26.83L36.3433 38.1273Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0711 60.7396C24.8784 60.6569 24.6464 60.2783 24.6464 59.8039V33.5841L16.7099 30.2897V56.3312C16.7099 56.8012 16.9419 57.1798 17.1345 57.2668L25.0711 60.7439V60.7396Z",
    fill: "url(#paint6_linear_12_13921)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.44
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6464 33.8669V33.5841L16.7099 30.2897V30.5726L24.6464 33.8669Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7572 60.7396C46.9498 60.6569 47.1819 60.2783 47.1819 59.8039V33.5841L55.1184 30.2897V56.3312C55.1184 56.8012 54.8864 57.1798 54.6938 57.2668L46.7572 60.7439V60.7396Z",
    fill: "url(#paint7_linear_12_13921)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.44
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1864 33.8669V33.5841L55.1229 30.2897V30.5726L47.1864 33.8669Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86728 26.6777L35.4328 15.2323C35.5816 15.1801 35.7305 15.1497 35.8881 15.1366C36.0413 15.1497 36.1945 15.1801 36.3433 15.2323L63.9089 26.6777L36.3433 38.123C36.1945 38.1753 36.0457 38.2057 35.8881 38.2188C35.7349 38.2057 35.5816 38.1753 35.4328 38.123L7.86728 26.6777Z",
    fill: "url(#paint8_linear_12_13921)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7145 30.3506L24.6511 33.6449L52.6719 22.0081C48.8371 20.4153 48.0973 20.1063 44.7353 18.7137L16.7145 30.3506Z",
    fill: "url(#paint9_linear_12_13921)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1352 21.9995L47.156 33.6363L55.0925 30.342L27.0717 18.7051L19.1352 21.9995Z",
    fill: "url(#paint10_linear_12_13921)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8881 16.2377C35.8662 16.242 35.8443 16.2464 35.8268 16.2551L10.7258 26.6777L35.8268 37.1004C35.8268 37.1004 35.8662 37.1135 35.8881 37.1178C35.91 37.1178 35.9319 37.1091 35.9494 37.1004V16.2551C35.9494 16.2551 35.91 16.242 35.8881 16.2377Z",
    fill: "#9C9C9C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9493 16.2549V37.1003L61.0547 26.6776L35.9493 16.2549Z",
    fill: "#C4C4C4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M35.827 16.5249C35.827 16.5249 35.8664 16.5119 35.8883 16.5075C35.9102 16.5119 35.9321 16.5162 35.9496 16.5249L60.731 26.817L61.0549 26.6821L35.954 16.2595C35.954 16.2595 35.9146 16.2464 35.8927 16.2421C35.8708 16.2464 35.8489 16.2508 35.8314 16.2595L10.7304 26.6821L11.0544 26.817L35.8314 16.5293L35.827 16.5249Z",
    fill: "url(#paint11_linear_12_13921)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69453 18.3743C6.67702 18.1915 6.75144 18.0218 6.87839 17.9L35.4201 29.7544C35.5733 29.811 35.7309 29.8414 35.8885 29.8545L35.8798 41.8046C35.6215 41.7742 35.3676 41.7132 35.1268 41.6044L7.35992 29.4672C6.97907 29.3061 6.72518 28.9493 6.69016 28.5402V18.3743H6.69453Z",
    fill: "url(#paint12_linear_12_13921)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M6.69453 18.3743C6.67702 18.1915 6.75144 18.0218 6.87839 17.9L35.4201 29.7544C35.5733 29.811 35.7309 29.8414 35.8885 29.8545L35.8798 41.8046C35.6215 41.7742 35.3676 41.7132 35.1268 41.6044L7.35992 29.4672C6.97907 29.3061 6.72518 28.9493 6.69016 28.5402V18.3743H6.69453Z",
    fill: "url(#paint13_linear_12_13921)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0826 18.3743C65.1001 18.1915 65.0257 18.0218 64.8987 17.9L36.357 29.7544C36.2038 29.811 36.0462 29.8414 35.8886 29.8545L35.8974 41.8046C36.1556 41.7742 36.4095 41.7132 36.6503 41.6044L64.4172 29.4672C64.7981 29.3061 65.052 28.9493 65.0914 28.5402V18.3743H65.0826Z",
    fill: "url(#paint14_linear_12_13921)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M65.0826 18.3743C65.1001 18.1915 65.0257 18.0218 64.8987 17.9L36.357 29.7544C36.2038 29.811 36.0462 29.8414 35.8886 29.8545L35.8974 41.8046C36.1556 41.7742 36.4095 41.7132 36.6503 41.6044L64.4172 29.4672C64.7981 29.3061 65.052 28.9493 65.0914 28.5402V18.3743H65.0826Z",
    fill: "url(#paint15_linear_12_13921)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M6.87817 18.1786L35.4199 6.32849C35.5731 6.27191 35.7307 6.24145 35.8883 6.22839C36.0503 6.24145 36.2035 6.27191 36.3567 6.32849L64.8984 18.1829L36.3567 30.0373C36.2035 30.0939 36.0459 30.1244 35.8883 30.1374C35.7263 30.1244 35.5731 30.0939 35.4199 30.0373L6.87817 18.1829V18.1786Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87817 17.8999L35.4199 6.04553C35.5731 5.98895 35.7307 5.95849 35.8883 5.94543C36.0503 5.95849 36.2035 5.98895 36.3567 6.04553L64.8984 17.8999L36.3567 29.7544C36.2035 29.8109 36.0459 29.8414 35.8883 29.8544C35.7263 29.8414 35.5731 29.8109 35.4199 29.7544L6.87817 17.8999Z",
    fill: "url(#paint16_linear_12_13921)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7103 21.9819C20.2955 23.4702 20.9171 23.727 24.6468 25.2762L53.6613 13.2303C49.8704 11.655 49.2225 11.3851 45.7248 9.93597L16.7147 21.9819H16.7103Z",
    fill: "url(#paint17_linear_12_13921)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1237 21.9819C51.5384 23.4702 50.9168 23.727 47.1871 25.2762L18.177 13.2303C21.968 11.655 22.6159 11.3851 26.1135 9.93597L55.1237 21.9819Z",
    fill: "url(#paint18_linear_12_13921)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M16.1238 21.9995C16.4083 21.3771 20.6896 22.4564 25.68 24.406C30.6704 26.3557 34.4877 28.4358 34.1987 29.0581C33.9142 29.6805 29.6329 28.6012 24.6425 26.6516C19.6521 24.702 15.8349 22.6218 16.1238 21.9995Z",
    fill: "url(#paint19_radial_12_13921)"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0714 37.2134C24.8788 37.1308 24.6468 36.7521 24.6468 36.2778V25.2763L16.7103 21.982V32.8007C16.7103 33.2707 16.9423 33.6493 17.1349 33.7363L25.0714 37.2134Z",
    fill: "url(#paint20_linear_12_13921)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.44
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6468 25.5636V25.2807L16.7103 21.9864V22.2693L24.6468 25.5636Z",
    fill: "white"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7578 37.2134C46.9504 37.1308 47.1824 36.7521 47.1824 36.2778V25.2763L55.119 21.982V32.8007C55.119 33.2707 54.887 33.6493 54.6943 33.7363L46.7578 37.2134Z",
    fill: "url(#paint21_linear_12_13921)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.44
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.187 25.5636V25.2807L55.1235 21.9864V22.2693L47.187 25.5636Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M51.4155 35.0071C49.2311 35.2639 47.0467 31.9913 46.5345 27.696C46.0224 23.4008 47.3794 19.7104 49.5594 19.4536C51.7438 19.1969 53.9282 22.4695 54.4404 26.7647C54.9526 31.06 53.5955 34.7504 51.4155 35.0071Z",
    fill: "url(#paint22_radial_12_13921)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M20.3656 35.0071C22.55 35.2639 24.7344 31.9913 25.2466 27.696C25.7588 23.4008 24.4017 19.7104 22.2217 19.4536C20.0373 19.1969 17.8529 22.4695 17.3407 26.7647C16.8285 31.06 18.1856 34.7504 20.3656 35.0071Z",
    fill: "url(#paint23_radial_12_13921)"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4021 37.1003C17.4021 37.1003 21.0662 27.8831 23.8547 24.9457L35.893 19.4362V16.2507L15.6161 21.5208C13.7906 22.8089 9.04099 32.6745 9.04099 32.6745L14.8325 31.4734C14.8325 31.4734 16.6623 35.3944 17.4065 37.1003H17.4021Z",
    fill: "url(#paint24_linear_12_13921)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03647 32.6787L14.828 31.4776C14.828 31.4776 16.6578 35.3986 17.402 37.1045C17.402 37.1045 21.066 27.8873 23.8545 24.9498L15.616 21.5293C13.7905 22.8174 9.04085 32.6831 9.04085 32.6831L9.03647 32.6787Z",
    fill: "url(#paint25_linear_12_13921)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3795 37.1003C54.3795 37.1003 50.7155 27.8831 47.927 24.9456L35.8887 19.4362V16.2506L56.1656 21.5207C57.991 22.8088 62.7407 32.6745 62.7407 32.6745L56.9491 31.4734C56.9491 31.4734 55.1193 35.3944 54.3751 37.1003H54.3795Z",
    fill: "url(#paint26_linear_12_13921)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7404 32.6787L56.9489 31.4775C56.9489 31.4775 55.1191 35.3986 54.3749 37.1045C54.3749 37.1045 50.7109 27.8873 47.9224 24.9498L56.1609 21.5292C57.9864 22.8174 62.736 32.683 62.736 32.683L62.7404 32.6787Z",
    fill: "url(#paint27_linear_12_13921)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5055 17.7041C11.6937 19.1446 14.2196 21.2378 19.3194 21.3771C24.4193 21.5163 28.4904 19.9801 30.0839 19.5406C31.6729 19.0967 34.8423 18.0305 34.8423 18.0305L32.3777 14.7753L13.9875 11.6594C13.9875 11.6594 11.8819 13.287 11.5055 17.7085V17.7041Z",
    fill: "url(#paint28_linear_12_13921)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8379 15.859C34.8379 15.859 31.6247 11.5638 30.0357 10.0276C28.4466 8.49137 22.782 5.18832 20.6283 3.88712C18.4745 2.58592 14.4034 3.97851 13.3265 5.1448C12.2496 6.3111 11.129 15.6589 11.5011 17.7042C11.5011 17.7042 11.2822 13.1609 17.4896 13.9834C22.2261 14.6101 26.1922 17.7521 28.9544 18.357C31.7167 18.9619 34.8335 18.0306 34.8335 18.0306V15.859H34.8379Z",
    fill: "url(#paint29_linear_12_13921)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9591 17.9827C26.1968 17.3778 22.2307 14.2357 17.4942 13.6091C13.4406 13.0738 11.9697 14.8798 11.4357 16.2028C11.4225 16.8512 11.4444 17.3734 11.5057 17.7042C11.5057 17.7042 11.2868 13.1608 17.4942 13.9833C22.2307 14.61 26.1968 17.752 28.9591 18.3569C31.7213 18.9618 34.8381 18.0306 34.8381 18.0306V17.6563C34.8381 17.6563 31.7169 18.5876 28.9591 17.9827Z",
    fill: "url(#paint30_linear_12_13921)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.41
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8381 16.7293C32.4042 15.3323 29.6901 13.9398 27.5363 12.8213C25.3826 11.7029 23.7629 11.1154 23.8548 11.3025C23.9467 11.4897 25.26 13.9398 27.3481 14.5882C29.4362 15.2366 30.0009 14.71 31.5287 15.3323C33.0564 15.9547 34.8381 18.0305 34.8381 18.0305V16.7293Z",
    fill: "#8A0314"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2759 17.704C60.0877 19.1445 57.5618 21.2377 52.462 21.377C47.3621 21.5162 43.291 19.98 41.6975 19.5405C40.1085 19.0966 36.9391 18.0304 36.9391 18.0304L39.4037 14.7752L57.7938 11.6593C57.7938 11.6593 59.8995 13.2869 60.2759 17.7084V17.704Z",
    fill: "url(#paint31_linear_12_13921)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M36.939 15.8589C36.939 15.8589 40.1522 11.5636 41.7412 10.0274C43.3303 8.49125 48.9948 5.1882 51.1486 3.887C53.3024 2.5858 57.3735 3.97839 58.4504 5.14468C59.5273 6.30662 60.6479 15.6587 60.2758 17.7041C60.2758 17.7041 60.4947 13.1608 54.2873 13.9833C49.5508 14.6099 45.5847 17.752 42.8225 18.3569C40.0602 18.9618 36.9434 18.0305 36.9434 18.0305V15.8589H36.939Z",
    fill: "url(#paint32_linear_12_13921)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8223 17.9826C45.5846 17.3777 49.5507 14.2356 54.2872 13.609C58.3408 13.0737 59.8117 14.8797 60.3457 16.2027C60.3589 16.8511 60.337 17.3733 60.2757 17.704C60.2757 17.704 60.4946 13.1607 54.2872 13.9832C49.5507 14.6099 45.5846 17.7519 42.8223 18.3568C40.0601 18.9617 36.9433 18.0304 36.9433 18.0304V17.6562C36.9433 17.6562 40.0645 18.5875 42.8223 17.9826Z",
    fill: "url(#paint33_linear_12_13921)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.41
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9391 16.7292C39.373 15.3322 42.0871 13.9396 44.2409 12.8212C46.3947 11.7028 48.0144 11.1153 47.9224 11.3024C47.8305 11.4895 46.5172 13.9396 44.4291 14.5881C42.341 15.2408 41.7763 14.7099 40.2486 15.3322C38.7208 15.9545 36.9391 18.0304 36.9391 18.0304V16.7292Z",
    fill: "#8A0314"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8882 19.4407C38.2434 19.4407 37.7443 17.4606 37.7443 17.4606L37.5736 15.8025C37.543 15.5023 37.3679 15.2237 37.0833 15.0323C36.7944 14.8408 36.3829 14.6493 35.8839 14.6493C35.3848 14.6493 34.9777 14.8408 34.6844 15.0323C34.3999 15.2194 34.2248 15.5023 34.1941 15.8025L34.0234 17.4606C34.0234 17.4606 33.5244 19.4407 35.8795 19.4407H35.8882Z",
    fill: "url(#paint34_linear_12_13921)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_12_13921",
    x: -0.60379,
    y: -3.52519,
    width: 73.0368,
    height: 80.0378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.78429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.12204
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12_13921"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12_13921",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -5.67644
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.02081
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_12_13921"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_13921",
    x1: -23.9488,
    y1: 77.3858,
    x2: 9.53025,
    y2: 54.2195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4BCBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_13921",
    x1: 25.4059,
    y1: 38.8192,
    x2: 17.5531,
    y2: 57.1397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FDFDFD",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F7F7F7",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EDEDED",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#E0E0E0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#CECECE",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B9B9B9",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_13921",
    x1: 21.722,
    y1: 26.6776,
    x2: 21.8561,
    y2: 41.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#BBBBBB",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C0C0C0",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C7C7C7",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D2D2D2",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E0E0E0",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F0F0F0",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12_13921",
    x1: 37.1792,
    y1: 33.9628,
    x2: 71.7368,
    y2: 67.2185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4BCBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12_13921",
    x1: 46.2429,
    y1: 38.8203,
    x2: 54.0972,
    y2: 57.1348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FDFDFD",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F7F7F7",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EDEDED",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#E0E0E0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#CECECE",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B9B9B9",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12_13921",
    x1: 35.9274,
    y1: 38.9283,
    x2: 35.9274,
    y2: 65.9575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12_13921",
    x1: 25.4475,
    y1: 35.2291,
    x2: 16.0026,
    y2: 56.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A000D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#54000D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#820312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A80515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C60618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#DB081A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E8081B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ED091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EB081B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E4081B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8071B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C7051A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B10419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#970118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12_13921",
    x1: 46.3808,
    y1: 35.2291,
    x2: 55.83,
    y2: 56.7901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A000D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#54000D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#820312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A80515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C60618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#DB081A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E8081B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ED091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EB081B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E4081B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8071B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C7051A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B10419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#970118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12_13921",
    x1: 24.073,
    y1: 18.3874,
    x2: 66.8265,
    y2: 48.7396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12_13921",
    x1: 38.1865,
    y1: 36.7347,
    x2: 33.2619,
    y2: 21.6862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F91F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E81606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#CC0807"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10308"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12_13921",
    x1: 52.4003,
    y1: 34.968,
    x2: 23.9651,
    y2: 18.4075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F91F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E81606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#CC0807"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10308"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12_13921",
    x1: 11.7373,
    y1: 19.3362,
    x2: 58.1339,
    y2: 28.0955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12_13921",
    x1: 1.27814,
    y1: 46.4468,
    x2: 19.9905,
    y2: 31.1845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4BCBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_12_13921",
    x1: 22.8813,
    y1: 26.4951,
    x2: 19.4041,
    y2: 34.6065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FDFDFD",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F7F7F7",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EDEDED",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#E0E0E0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#CECECE",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B9B9B9",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_12_13921",
    x1: 41.8596,
    y1: 21.7252,
    x2: 64.9735,
    y2: 43.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4BCBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_12_13921",
    x1: 48.7725,
    y1: 26.4943,
    x2: 52.2474,
    y2: 34.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FDFDFD",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F7F7F7",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EDEDED",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#E0E0E0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#CECECE",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B9B9B9",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_12_13921",
    x1: 0.924684,
    y1: 7.30756,
    x2: 82.5104,
    y2: 32.3115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_12_13921",
    x1: 30.6353,
    y1: 27.5566,
    x2: 33.6221,
    y2: 20.9416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_12_13921",
    x1: 41.1986,
    y1: 27.5566,
    x2: 38.2118,
    y2: 20.9416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800017"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_12_13921",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.98437 37.9661) rotate(-158.675) scale(9.77095 1.14456)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_12_13921",
    x1: 22.8958,
    y1: 25.0762,
    x2: 18.778,
    y2: 34.4679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_12_13921",
    x1: 48.9335,
    y1: 25.0762,
    x2: 53.0513,
    y2: 34.4679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800017"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_12_13921",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.7636 27.9583) rotate(83.2004) scale(7.43203 3.81364)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F0011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F0011",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_12_13921",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7747 28.0025) rotate(96.7996) scale(7.43203 3.81364)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F0011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F0011",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_12_13921",
    x1: 22.5764,
    y1: 26.8431,
    x2: 22.2822,
    y2: 20.5936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_12_13921",
    x1: 18.7766,
    y1: 23.344,
    x2: 10.737,
    y2: 42.4217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_12_13921",
    x1: 49.2052,
    y1: 26.843,
    x2: 49.4994,
    y2: 20.5936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_12_13921",
    x1: 53.0047,
    y1: 23.344,
    x2: 61.0443,
    y2: 42.4217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_12_13921",
    x1: 23.0272,
    y1: 21.3031,
    x2: 23.2262,
    y2: 16.4812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_12_13921",
    x1: 12.0264,
    y1: 9.60979,
    x2: 33.9171,
    y2: 15.8001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A000D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#830312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B10516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D10719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E5081B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ED091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4081B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#CE061A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#A90318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_12_13921",
    x1: 11.2343,
    y1: 15.3759,
    x2: 36.5345,
    y2: 17.5422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ED1C2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ED2D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ED3444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ED3040",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ED2637",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ED1628",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ED091C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_12_13921",
    x1: 49.3101,
    y1: 21.6076,
    x2: 48.4272,
    y2: 16.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_12_13921",
    x1: 59.7505,
    y1: 9.60967,
    x2: 37.8598,
    y2: 15.7999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A000D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#830312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B10516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D10719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E5081B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ED091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4081B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#CE061A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#A90318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_12_13921",
    x1: 60.5427,
    y1: 15.3758,
    x2: 35.2426,
    y2: 17.5421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ED1C2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ED2D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ED3444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ED3040",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ED2637",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ED1628",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ED091C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_12_13921",
    x1: 34.969,
    y1: 14.893,
    x2: 36.8581,
    y2: 19.7615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ED091C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#E4081B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CE061A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#A90318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800017"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.071a20c8498742c9ed7d4c60c307ac03.svg";
export { ForwardRef as ReactComponent };